import React from 'react';
import { HomeIcon, HammerIcon, WrenchIcon, ShieldIcon, WindIcon, ZapIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: HomeIcon,
    title: 'Home Re-Leveling',
    items: ['Doors/Windows Opening Poorly', 'Drywall/Ceiling Cracks', 'Door Gaps/Floor Bumps', 'Wavy Siding/Skirting'],
    special: '$100 OFF Re-Level Jobs'
  }, {
    icon: ShieldIcon,
    title: 'Roofing Repairs',
    items: ['White/Aluminum Coating', 'Leaky Skylights/Vents', 'Wind/Storm Damage', 'Loose Shingles'],
    special: '$50 OFF Roof Coating or Leaks'
  }, {
    icon: HammerIcon,
    title: 'Service & Repairs',
    items: ['Insulation', 'Skirting', 'Decks', 'Steps', 'Power Washing', 'Flooring', 'Doors', 'Windows']
  }, {
    icon: ZapIcon,
    title: 'Animal Damage',
    items: ['Torn Insulation', 'Torn Ducts', 'Vapor Barrier Damage', 'Strange Odors or Smells', 'Skirting Damage']
  }, {
    icon: WrenchIcon,
    title: 'Additional Services',
    items: ['Siding', 'Gutters', 'Sheds', 'Painting', 'Drywall', 'Remodeling']
  }, {
    icon: WindIcon,
    title: 'Hurricane Preparation',
    items: ['Check Loose Straps', 'Add Tie-Downs/Stabilizer Plates', 'Replace Ground Anchors', 'Home Safety Inspection']
  }];
  return <div className="w-full bg-white py-20 px-4" data-id="element-76">
      <div className="max-w-7xl mx-auto" data-id="element-77">
        <div className="text-center mb-16" data-id="element-78">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-79">
            Our Services
          </h2>
          <p className="text-xl text-gray-700" data-id="element-80">
            Comprehensive Mobile Home Repair Solutions
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-81">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="bg-gray-50 p-6 rounded-lg border-2 border-gray-200 hover:border-yellow-400 transition-colors" data-id="element-82">
                <div className="flex items-center gap-4 mb-4" data-id="element-83">
                  <div className="bg-yellow-400 w-12 h-12 rounded-lg flex items-center justify-center" data-id="element-84">
                    <Icon className="w-6 h-6 text-red-600" data-id="element-85" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-86">
                    {service.title}
                  </h3>
                </div>
                <ul className="space-y-2 mb-4" data-id="element-87">
                  {service.items.map((item, idx) => <li key={idx} className="text-gray-700 flex items-start" data-id="element-88">
                      <span className="text-red-600 mr-2" data-id="element-89">•</span>
                      {item}
                    </li>)}
                </ul>
                {service.special && <div className="bg-red-600 text-white px-4 py-2 rounded font-bold text-center" data-id="element-90">
                    {service.special}
                  </div>}
              </div>;
        })}
        </div>
        <div className="mt-12 bg-black text-white p-6 rounded-lg text-center" data-id="element-91">
          <p className="text-2xl font-bold" data-id="element-92">
            PROFESSIONALLY TRAINED STAFF • COMPLETE MOBILE HOME REPAIR
          </p>
        </div>
      </div>
    </div>;
}